// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_3L2nkNevDj4EslXoYjoA9H","icon":"_118LGmue2851JIiSFi5xUN"};